// 核心流程接口文档：https://helios-saas.yuque.com/docs/share/17b75a26-5ecf-4a8b-9a08-043e260c97cc?#tHba
export const WHITE_LIST_URL_MAP = new Map([
  [
    '/api/audit/pass',
    {
      apiModule: 'audit',
      moduleName: '审核',
      moduleAction: '审核通过',
    },
  ],
  [
    '/api/audit/reject',
    {
      apiModule: 'audit',
      moduleName: '审核',
      moduleAction: '审核驳回',
    },
  ],
  [
    '/api/approvals/reject',
    {
      apiModule: 'approval',
      moduleName: '工作流',
      moduleAction: '审批驳回',
    },
  ],
  [
    '/api/approvals/pass',
    {
      apiModule: 'approval',
      moduleName: '工作流',
      moduleAction: '审批通过',
    },
  ],
  [
    '/api/approvals/batch/pass',
    {
      apiModule: 'approval',
      moduleName: '工作流',
      moduleAction: '批量审批通过',
    },
  ],
  [
    '/api/approvals/reject/expensereport/invoice',
    {
      apiModule: 'approval',
      moduleName: '审批',
      moduleAction: '费用驳回错误',
    },
  ],
  [
    '/api/travel/applications/submit',
    {
      apiModule: 'application',
      moduleName: '申请单',
      moduleAction: '提交错误',
    },
  ],
  [
    '/api/travel/applications/submit/v2',
    {
      apiModule: 'application',
      moduleName: '申请单',
      moduleAction: '提交新版差旅申请单',
    },
  ],
  [
    '/api/loanBill/submit/v2',
    {
      apiModule: 'loanBill',
      moduleName: '借款单',
      moduleAction: '提交借款单',
    },
  ],
  [
    '/api/v3/expense/report/submit',
    {
      map: (reqParams) => {
        if (reqParams?.corporateFlag) {
          return {
            apiModule: 'corpPayment',
            moduleName: '对公支付单',
            moduleAction: '提交对公支付单',
          };
        } else {
          return {
            apiModule: 'expenseClaim',
            moduleName: '报销单',
            moduleAction: '提交报销单',
          };
        }
      },
    },
  ],
  [
    '/api/expense/reports/custom/form/draft',
    {
      map: (reqParams) => {
        if (reqParams?.corporateFlag) {
          return {
            apiModule: 'corpPayment',
            moduleName: '对公支付单',
            moduleAction: '保存对公支付单',
          };
        } else {
          return {
            apiModule: 'expenseClaim',
            moduleName: '报销单',
            moduleAction: '保存报销单',
          };
        }
      },
    },
  ],
  [
    '/invoice/api/v5/invoices',
    {
      apiModule: 'expenseList',
      moduleName: '费用',
      moduleAction: '保存费用',
    },
  ],
  [
    '/api/v3/expense/default/apportionment',
    {
      apiModule: 'expense',
      moduleName: '费用',
      moduleAction: '查询费用默认分摊',
    },
  ],
  [
    '/api/invoice/audit/save/invoice',
    {
      apiModule: 'expense',
      moduleName: '费用',
      moduleAction: '财务编辑费用',
    },
  ],
  [
    '/api/prepayment/line',
    {
      apiModule: 'prepayment',
      moduleName: '付款行',
      moduleAction: '保存付款行',
    },
  ],
  [
    '/api/corp/payment/schedule',
    {
      apiModule: 'corpPayment',
      moduleName: '对公支付单',
      moduleAction: '保存对公付款行',
    },
  ],
  [
    '/v1/api/corp/payment/schedule',
    {
      apiModule: 'corpPayment',
      moduleName: '对公支付单',
      moduleAction: '保存对公付款行',
    },
  ],
  [
    '/api/expense/report/application/check',
    {
      apiModule: 'expenseClaim',
      moduleName: '报销单',
      moduleAction: '提交校验',
    },
  ],
  [
    '/api/travel/standards/validate',
    {
      apiModule: 'expenseClaim',
      moduleName: '报销单',
      moduleAction: '提交校验(差旅标准校验)',
    },
  ],
  [
    '/api/expense/report/submit/invoice/discount/check',
    {
      apiModule: 'expenseClaim',
      moduleName: '报销单',
      moduleAction: '提交校验（费用逾期扣减管控校验）',
    },
  ],
  [
    '/budget-service/api/budget/journals',
    {
      apiModule: 'budgetJournals',
      moduleName: '预算日记账',
      moduleAction: '保存预算日记账',
    },
  ],
  [
    '/budget-service/api/budget/journals/submitJournal',
    {
      apiModule: 'budgetJournals',
      moduleName: '预算日记账',
      moduleAction: '提交预算日记账',
    },
  ],
  [
    '/receipt/api/receipt/ocr',
    {
      apiModule: 'receipt',
      moduleName: '发票',
      moduleAction: '发票识别(图片)',
    },
  ],
  [
    '/receipt/api/receipt/ocr/v2',
    {
      apiModule: 'receipt',
      moduleName: '发票',
      moduleAction: '发票识别(PDF)',
    },
  ],
  [
    '/receipt/api/receipt/verify/batch',
    {
      apiModule: 'receipt',
      moduleName: '发票',
      moduleAction: '发票查验',
    },
  ],
  [
    '/receipt/api/receipt/verify',
    {
      apiModule: 'receipt',
      moduleName: '发票',
      moduleAction: '发票查验',
    },
  ],
  [
    '/api/bill/recoil',
    {
      apiModule: 'audit',
      moduleName: '审核',
      moduleAction: '审核反冲',
    },
  ],
  [
    '/api/expense/reports/bag/details/add',
    {
      apiModule: 'receiptsBag',
      moduleName: '发票袋',
      moduleAction: '新增发票袋关联报销单',
    },
  ],
  [
    '/contract/api/contract/header/edit/v2',
    {
      apiModule: 'contract',
      moduleName: '合同',
      moduleAction: '保存合同',
    },
  ],
  [
    '/contract/api/contract/header/v2/submit/',
    {
      apiModule: 'contract',
      moduleName: '合同',
      moduleAction: '提交合同',
    },
  ],
  [
    '/api/loanBill/draft',
    {
      apiModule: 'loanBill',
      moduleName: '借款单',
      moduleAction: '保存借款单',
    },
  ],
  [
    '/ledger/api/journal/preview',
    {
      apiModule: 'finance',
      moduleName: '财务',
      moduleAction: '凭证预览',
    },
  ],
  [
    '/v1/ledger/api/journal/preview',
    {
      apiModule: 'finance',
      moduleName: '财务',
      moduleAction: '凭证预览',
    },
  ],
  [
    '/ledger/api/function/source/group/segment/copy',
    {
      apiModule: 'finance',
      moduleName: '财务',
      moduleAction: '核算',
    },
  ],
  [
    '/payment/api/cash/transactionData/scanCode/query',
    {
      apiModule: 'finance',
      moduleName: '财务',
      moduleAction: '扫码枪支付',
    },
  ],
  [
    '/v1/payment/api/cash/transactionData/scanCode/query',
    {
      apiModule: 'finance',
      moduleName: '财务',
      moduleAction: '扫码枪支付',
    },
  ],
  [
    '/payment/api/cash/bankPay/paymentCheck',
    {
      apiModule: 'finance',
      moduleName: '财务',
      moduleAction: '确认支付',
    },
  ],
  [
    '/payment/api/cash/bankPay/createOrder',
    {
      apiModule: 'finance',
      moduleName: '财务',
      moduleAction: '银企直连下单',
    },
  ],
  [
    '/api/travel/applications/draft',
    {
      apiModule: 'application',
      moduleName: '申请单',
      moduleAction: '保存新版差旅申请单',
    },
  ],
  [
    '/api/expense/applications/draft',
    {
      apiModule: 'application',
      moduleName: '申请单',
      moduleAction: '保存费用申请单',
    },
  ],
  [
    '/api/expense/applications/submit/v2',
    {
      apiModule: 'application',
      moduleName: '申请单',
      moduleAction: '提交费用申请单',
    },
  ],
  [
    '/api/public/applications/draft',
    {
      apiModule: 'application',
      moduleName: '申请单',
      moduleAction: '保存对公申请单',
    },
  ],
  [
    '/api/public/applications/submit/v2',
    {
      apiModule: 'application',
      moduleName: '申请单',
      moduleAction: '提交对公申请单',
    },
  ],
  [
    '/api/application/submit/check',
    {
      apiModule: 'application',
      moduleName: '申请单',
      moduleAction: '提交校验',
    },
  ],
  [
    '/api/travel/application/city/risk/check',
    {
      apiModule: 'application',
      moduleName: '申请单',
      moduleAction: '提交校验(风险城市)',
    },
  ],
  [
    '/api/approval/history/get/common',
    {
      apiModule: 'approval',
      moduleName: '工作流',
      moduleAction: '通用审批历史',
    },
  ],
  [
    '/api/v2/expense/reports/approval/history',
    {
      apiModule: 'approval',
      moduleName: '工作流',
      moduleAction: '查询报销单审批历史',
    },
  ],
  [
    '/api/countersign/addSign/enable/and/scope',
    {
      apiModule: 'approval',
      moduleName: '工作流',
      moduleAction: '加签',
    },
  ],
  [
    '/proxy/oauth/token',
    {
      apiModule: 'loginRegister',
      moduleName: '登录注册',
      moduleAction: '登录',
    },
  ],
  [
    '/proxy/api/refactor/activation/email/or/mobile/token',
    {
      apiModule: 'loginRegister',
      moduleName: '登录注册',
      moduleAction: '登录',
    },
  ],
  [
    '/api/refactor/activate/email/or/mobile',
    {
      apiModule: 'loginRegister',
      moduleName: '登录注册',
      moduleAction: '账号激活',
    },
  ],
  [
    '/v1/api/refactor/activate/email/or/mobile',
    {
      apiModule: 'loginRegister',
      moduleName: '登录注册',
      moduleAction: '账号激活',
    },
  ],
  [
    '/proxy/api/refactor/account/reset_password/init/v3',
    {
      apiModule: 'loginRegister',
      moduleName: '登录注册',
      moduleAction: '忘记密码',
    },
  ],
  [
    '/api/refactor/users/v2',
    {
      apiModule: 'staffManage',
      moduleName: '人员管理',
      moduleAction: '新增员工',
    },
  ],
  [
    '/api/common/upload',
    {
      apiModule: 'uploadDownload',
      moduleName: '上传下载',
      moduleAction: '导入模板上传',
    },
  ],
]);

export const GROUP_BY_URL = {
  基础组: [
    'account',
    'activate',
    'activation',
    'all',
    'apportion',
    'areas',
    'attachments',
    'auth',
    'authority',
    'authorization',
    'bank',
    'baoku',
    'batch',
    'bills',
    'budget',
    'carousels',
    'check',
    'common',
    'commonFunction',
    'commonproblem',
    'companies',
    'company',
    'config',
    'contact',
    'control',
    'cost',
    'costcenter',
    'custom/enumerations',
    'customer',
    'customizedApiCallback',
    'customizedPage',
    'customizedQuery',
    'dashboard',
    'data',
    'dataOperation',
    'department',
    'DepartmentGroup',
    'DepartmentGroupDetail',
    'departmentposition',
    'departmentpositionuser',
    'departments',
    'dept',
    'documentContent',
    'emailConfig',
    'entity',
    'feedback',
    'function',
    'home',
    'hydra',
    'legal',
    'legalEntity',
    'legalentitys',
    'levels',
    'lov',
    'mail',
    'messages',
    'mobilevalidate',
    'my',
    'operation',
    'options',
    'outer',
    'personal',
    'purchase',
    'queryCriteria',
    'refactor',
    'remind',
    'remove/user',
    'search',
    'security',
    'select/user',
    'setOfBooks',
    'shortcut',
    'system',
    'tableColumn',
    'tableview',
    'tenant',
    'thirdParty',
    'trial',
    'trialService',
    'udesk',
    'upload',
    'user',
    'userFieldFormSetting',
    'users',
    'v2/my/company',
    'v2/users',
    'v3/all/company',
    'v3/users',
    'version',
    'versions',
    'wechat',
    'widget',
    'work/calendar',
    'dataOperation',
    'dingtalk',
    'feishu',
    'city',
    'cityLevel',
    'cityLevelArea',
    'bsp',
    'getCardSign',
    'authorizedUser',
    'project',
    'measurementUnit',
  ],
  报销单组: [
    'accrued',
    'audit',
    'book',
    'corp',
    'corporate',
    'deduction',
    'delivery',
    'exp',
    'expense',
    'finance',
    'invoice',
    'key',
    'label',
    'mark',
    'order',
    'originpayment',
    'outstanding',
    'payment',
    'pcfp',
    'public/car',
    'quick',
    'receipt',
    'report',
    'reset/expense',
    'reverse',
    'review',
    'scan',
    'setFreePrintPasteConfig',
    'ssc/check',
    'surrender',
    'tax',
    'trading/platform',
    'travelstandardsettings',
    'v2/all/company',
    'v2/expense',
    'v2/invoice',
    'v3/expense',
    'bill/recoil',
    'custom/print',
    'v3/subsidy',
    'bankcard',
    'setFreePrintPasteConfig',
    'sharing',
  ],
  申请单组: [
    'admin',
    'applicant',
    'application',
    'applications',
    'approval',
    'approvals',
    'bill',
    'billProxyRule',
    'cf',
    'controlled',
    'countersign',
    'custom/forms',
    'customForm',
    'document',
    'form',
    'obj/standard/',
    'obj/tmp',
    'public/application',
    'public/applications',
    'travel',
    'train',
    'v2/custom',
    'v2/travel',
    'validate',
    'workflow',
    'custom/system',
  ],
  财务组: [
    'alipayAccount',
    'cash',
    'comapnyBankPayment',
    'CompanyBank',
    'companyBankAuth',
    'contract',
    'currency',
    'default',
    'fm',
    'global',
    'journal',
    'ledger',
    'loan',
    'loanAmountMax',
    'loanBill',
    'periods',
    'prepayment',
    'receipted',
    'reimbursement',
    'repayment',
    'template/download',
    'open/ledger',
  ],
  消费平台: [
    'ctrip',
    'register',
    'standardprice',
    'supplier',
    'suppliers',
    'suppliers2',
    'ven',
    'vendor-data-service',
    'vendor-info-service',
    'vendor',
    'vendors',
    'zhenxuan',
    'vendor-sync-service',
    'didi',
    'esmart',
    'tongcheng',
    'bestdo',
    'fasco',
    'huazhu',
    'hrs',
    'jingdong',
    'jd',
    'meiya',
    'sso',
  ],
  E档案: ['archive'],
  其他: [
    'bankcard',
    'billing',
    'bpo',
    'bulk',
    'cache',
    'category',
    'change',
    'charge',
    'client',
    'credit',
    'currencyI18n',
    'dining',
    'enc',
    'esmart',
    'external',
    'fasco',
    'find',
    'hystrix',
    'implement',
    'init',
    'nachaTemplate',
    'paymentCompanyConfig',
    'polyv',
    'private',
    'process',
    'query',
    'rec',
    'referenced',
    'scheduled',
    'sharding',
    'taskConfig',
    'transfer',
    'travelRecords',
    'yget',
  ],
};

export const GROUP_BY_ROUTE_PATH = {
  基础组: [
    '/loading',
    '/main/approve/approve-my-supplier',
    '/main/basic-data/bank-definition',
    '/main/common-question',
    '/main/contact-maintain',
    '/main/customer-feedback',
    '/main/customer-info-maintenance',
    '/main/dashboard',
    '/main/home',
    '/main/data-analysis/data-center',
    '/main/data-analysis/data-report-distribution',
    '/main/data-analysis/data-report-management',
    '/main/data-analysis/report/custom-report',
    '/main/data-analysis/report/graphic-report',
    '/main/data-analysis/report/third-report',
    '/main/data-analysis/report/travel-report',
    '/main/data-analysis/report/universal-report',
    '/main/employee-clocking-information',
    '/main/enterprise-manage',
    '/main/help-center-admin/question-maintenance',
    '/main/help-center-user',
    '/main/help-document-management',
    '/main/increment-service',
    '/main/intelligent-analysis',
    '/main/messages-center',
    '/main/my-supplier',
    '/main/permission-setting',
    '/main/personal-settings',
    '/main/purchase-history',
    '/main/setting/announcement-information',
    '/main/setting/callback-setting',
    '/main/setting/cascade-values-setting',
    '/main/setting/city-group',
    '/main/setting/coding-rule-object',
    '/main/setting/control-rules',
    '/main/setting/cost-center',
    '/main/setting/customer-type-define',
    '/main/setting/department-management',
    '/main/setting/development-platform-index',
    '/main/setting/feedback-management',
    '/main/setting/function-profile',
    '/main/setting/login-log',
    '/main/setting/manage-menus',
    '/main/setting/measure-material',
    '/main/setting/measure-unit',
    '/main/setting/notification-setting',
    '/main/setting/operation-log',
    '/main/setting/operations-personnel-authorization',
    '/main/setting/person-group',
    '/main/setting/security-setting',
    '/main/setting/sub-application',
    '/main/setting/supplier-type',
    '/main/setting/user-agreement',
    '/main/setting/value-list',
    '/main/setting/work-calendar',
    '/main/sub-application-view',
    '/main/supplier-maintain',
    '/main/unbox-setting',
    '/main/update-log',
  ],
  报销单组: [
    '/main/approve/approve-budget-journal',
    '/main/approve/approve-corporate-payment-report',
    '/main/approve/approve-expense-report',
    '/main/budget-setting',
    '/main/budget',
    '/main/corporate-payment-report',
    '/main/expense-parent-report',
    '/main/expense-reimbursement-control/mileage-subsidy',
    '/main/mileage-subsidy-expense',
    '/main/my-account',
    '/main/approve/approve-payment',
    '/main/scan-receive',
    '/main/scan-return',
    '/main/setting/claim-amount-verification',
    '/main/setting/configuration-center',
    '/main/setting/receipt-type',
    '/main/setting/invoice-management-control',
    '/main/setting/invoice-to-cost',
    '/main/setting/price-tax-seperation-rule',
    '/main/setting/invoice-validation-settings',
    '/main/setting/cost-base-setting',
    '/main/setting/custom-printing',
    '/main/setting/expense-control',
    '/main/setting/expense-setting',
    '/main/setting/expense-type',
    '/main/setting/invoice-bag',
    '/main/setting/invoice-management-check',
    '/main/setting/invoice-source-check',
    '/main/setting/reimb-submission-control',
    '/main/setting/reimbursement-standard',
    '/main/setting/tag-settings',
    '/main/supplier/allocation-setting',
  ],
  申请单组: [
    '/main/ap-request',
    '/main/approve/approve-other',
    '/main/approve/approve-request',
    '/main/credit-setting',
    '/main/credit',
    '/main/expense-reimbursement-control/subsidy-rule',
    '/main/my-agency',
    '/main/my-document',
    '/main/payment/payment-request',
    '/main/request',
    '/main/setting/agency-setting',
    '/main/setting/application-setting',
    '/main/setting/approval-matrix',
    '/main/setting/approve-suggest',
    '/main/setting/business-scenarios-management',
    '/main/setting/form-list',
    '/main/setting/parameter',
    '/main/setting/process-monitoring-platform',
    '/main/setting/subflow',
    '/main/setting/workflow',
    '/main/travel-standard',
  ],
  财务组: [
    '/main/accrual',
    '/main/approve/approve-accrual',
    '/main/approve/approve-contract',
    '/main/approve/approve-loan',
    '/main/approve/payment-batch-detail',
    '/main/approve/salary-payment-detail',
    '/main/borrowing-repayment-setting',
    '/main/contract',
    '/main/finance-setting',
    '/main/financial-account',
    '/main/financial-management',
    '/main/loan-billing',
    '/main/my-accounts-receivables',
    '/main/pay-setting',
    '/main/pay',
    '/main/payment-batch-detail',
    '/main/setting/accounting-monitoring-platform',
    '/main/setting/contract-type-define',
    '/main/setting/currency-setting',
    '/main/setting/e-signature',
    '/main/setting/type-of-advance-payment',
    '/main/supplier/period-manage',
    '/main/salary-payment',
  ],
  消费平台: [
    '/main/booking-management',
    '/main/booking-operate-management',
    '/main/confirm-consumption',
    '/main/consumption-bills-management/consumption-bills',
    '/main/consumption-platform/third-consumption',
    '/main/data-analysis/report/air-report',
    '/main/data-analysis/report/car-report',
    '/main/data-analysis/report/flight-report',
    '/main/data-analysis/report/hotel-report',
    '/main/settlement-confirm',
    '/main/supplier/air-ticket-quotation',
    '/main/supplier/airline-platform',
    '/main/supplier/consumer-card-list',
    '/main/supplier/consumer-order-center',
    '/main/supplier/supplier-account-settings',
  ],
  E档案: ['/archives'],
  其他: [],
};

export const GROUP_BY_ROUTE_PATH_WE_CHAT = {
  报销单组: [
    '/balance-detail',
    '/budget-detail',
    '/budget-journal',
    '/budget-list',
    '/business-account-detail',
    '/business-card-list',
    '/claim-rule',
    '/claim-setting-detail',
    '/common/detail',
    '/control-list',
    '/corporate-budget-list',
    '/corp-payment',
    '/create-list-business',
    '/detail/budget-report',
    '/email-receipt-list',
    '/entering-invoice',
    '/expense-claim',
    '/expense-detail',
    '/expense-invoice-detail',
    '/expense-list',
    '/expense-report',
    '/express-delivery',
    '/financial-audit-detail',
    '/function',
    '/hand',
    '/helios-pay',
    '/import-application-invoice',
    '/import-invoice',
    '/invoice-bag',
    '/main/waveTravel',
    '/mile',
    '/my-document',
    '/ocr-file',
    '/ocr-tool-tip',
    '/outstanding-business-list',
    '/payment-request',
    '/payment-requisition',
    '/pay-to-me/list',
    '/pc-scan-view',
    '/personnel/analysis/report',
    '/personnel-analysis-selector',
    '/power-scan',
    '/public-pay-poll',
    '/receipt-list',
    '/scan',
    '/receipt-fold',
  ],
  申请单组: [
    '/A-card-pack',
    '/application/AcceptanceForm',
    '/application/create',
    '/application/detail',
    '/application/linkFormTree',
    '/application/list',
    '/application/particulars-subsidies',
    '/application/travel-card',
    '/application/travel-policy-search',
    '/apRequest/list',
    '/my-info/agent-approval',
    '/my-info/credit',
    '/workflow-list',
    '/voice-record',
  ],
  财务组: [
    '/accrual',
    '/application/refund',
    '/application/request-budget-list',
    '/arrears-statistics',
    '/associated-info',
    '/contract',
    '/corporate-refund',
    '/invoice-type-introduce',
    '/lease-info',
    '/loan-bill',
    '/loan-line/detail',
    '/loan-list/',
    '/payment-batch/detail',
    '/salary-payment',
  ],
  消费平台: [
    '/application/multiple-vendors',
    '/application/multiple-category',
    '/didi-synchronizaiton',
    '/explanation',
    '/main/didi',
    '/mice/detail',
    '/mice/list',
    '/myInfo/bind',
    '/universalForm',
  ],
  E档案: [],
  demo: [
    '/xcAirport',
    '/xcAirportList',
    '/xcHotel',
    '/xcHotelList',
    '/xcHotelDetail',
    '/orderComplete',
    '/fillInOrder',
    '/checkApprovalSheet',
    '/didiExp',
    '/didiTrip',
    '/didiPay',
    '/citsAirport',
    '/citsAirportList',
    '/citsAirportDetails',
    '/bookingSuccess',
    '/approvalList',
    '/citsHotel',
    '/citsHotelList',
    '/citsHotelDetails',
    '/citsHotelOrder',
    '/demoDetail',
    '/demolist',
    '/front-detection',
  ],
  基础组: [
    '/',
    '/Activate',
    '/airplane-ticket-confirm',
    '/mi-abnormal-list',
    '/announcement',
    '/app-expired',
    '/application/manage',
    '/bind-phone',
    '/carbon-report',
    '/carousel',
    '/confirm-code',
    '/confirm-login',
    '/contact-us',
    '/detail/report',
    '/dingbind',
    '/feedback',
    '/found-password',
    '/gtMain',
    '/gtMore',
    '/hlyIFrame',
    '/invoice-detail',
    '/invoice-info',
    '/login',
    '/main/more',
    '/main/report',
    '/myCalendar',
    '/myInfo',
    '/myInfo/bankCard',
    '/myInfo/certificatesEdit',
    '/my-supplier',
    '/protocol',
    '/push',
    '/refactor/main',
    '/refresh',
    '/report-entry',
    '/reset-password',
    '/role-config',
    '/send-confirm-code',
    '/set-gender-birthday',
    '/set-login-password',
    '/setpassword',
    '/set-password',
    '/set-phone',
    '/supplier/info-card',
    '/supplier-middle-view',
    '/trial-login',
  ],
  其他: [],
};
